import LoaderInline from '@jetbrains/ring-ui/components/loader-inline/loader-inline'
import {memo} from 'react'
import Measure from 'react-measure'

import type {BuildTypeId, ProjectId, TestId, TestOccurrenceId} from '../../../../types'
import SequenceLoader from '../../../common/SequenceLoader/SequenceLoader'
import TestHistoryChart from '../../../packages/Tests/TestHistoryChart/TestHistoryChart'

import InvestigationsPanel from './InvestigationsPanel/InvestigationsPanel'
import MutesPanel from './MutesPanel/MutesPanel'
import TestHistoryList from './TestHistoryList/TestHistoryList'

import styles from './OverviewTab.css'

type Props = {
  projectId: ProjectId
  buildTypeId: BuildTypeId
  testId: TestId
  testOccurrenceId: TestOccurrenceId
}

function OverviewTab({projectId, buildTypeId, testId, testOccurrenceId}: Props) {
  return (
    <Measure client>
      {({measureRef, contentRect}) => (
        <div className={styles.page}>
          <div ref={measureRef} />
          {contentRect.client?.width != null || process.env.NODE_ENV === 'test' ? (
            <SequenceLoader>
              <TestHistoryChart
                seqKey="TestHistoryChart"
                width={contentRect.client?.width ?? 0}
                testId={testId}
                projectId={projectId}
                buildTypeId={buildTypeId}
              />
              <InvestigationsPanel
                seqKey="InvestigationsPanel"
                testOccurrenceId={testOccurrenceId}
                seqOff
              />
              <MutesPanel seqKey="MutesPanel" testOccurrenceId={testOccurrenceId} seqOff />
              <TestHistoryList
                seqKey="TestHistoryList"
                testId={testId}
                projectId={projectId}
                buildTypeId={buildTypeId}
              />
            </SequenceLoader>
          ) : (
            <LoaderInline>{'Loading...'}</LoaderInline>
          )}
        </div>
      )}
    </Measure>
  )
}

export default memo<Props>(OverviewTab)
